import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Sparkles, Loader2 } from 'lucide-react';

const AIEstimationDialog = ({
 open,
 onOpenChange,
 fieldLabel,
 prompt,
 setPrompt,
 onEstimate,
 loading
}) => {
 return (
 <Dialog open={open} onOpenChange={onOpenChange}>
 <DialogContent className="sm:max-w-md">
 <DialogHeader>
 <DialogTitle className="flex items-center gap-2">
 <Sparkles className="w-5 h-5 text-blue-600" />
 AI Estimation: {fieldLabel}
 </DialogTitle>
 <DialogDescription>
 Ask AI to estimate this value based on your product and location
 </DialogDescription>
 </DialogHeader>
 <div className="space-y-4 py-4">
 <Input
 value={prompt}
 onChange={(e) => setPrompt(e.target.value)}
 placeholder="e.g., What's a typical sales tax rate in Seattle?"
 onKeyPress={(e) => e.key === 'Enter' && !loading && onEstimate()}
 />
 <Button 
 onClick={onEstimate} 
 disabled={loading || !prompt.trim()}
 className="w-full"
 >
 {loading ? (
 <>
 <Loader2 className="w-4 h-4 mr-2 animate-spin" />
 Asking AI...
 </>
 ) : (
 <>
 <Sparkles className="w-4 h-4 mr-2" />
 Get AI Estimate
 </>
 )}
 </Button>
 </div>
 </DialogContent>
 </Dialog>
 );
};

export default AIEstimationDialog;
